import { Box, Stack, styled } from '@mui/material';

import { Typography } from '@/shared/design-system';
import { forMobile } from '@/styles/responsive';

export const GradientTypography = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'gradient',
})<{ gradient?: string }>(({ gradient }) => ({
  display: 'inline-block',
  backgroundImage: gradient ?? 'linear-gradient(90deg, #FFFFFF 0%, rgba(190, 190, 190, 0.44) 100%)',
  WebkitBackgroundClip: 'text',
  backgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  color: 'transparent',
}));

export const ReferralProgramDashboardWrapper = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: '16px',
  gridTemplateColumns: '496px 1fr',
  alignItems: 'stretch',
  width: '100%',

  [forMobile(theme)]: {
    gap: '16px',
    gridTemplateColumns: '1fr',
  },

  '@media (max-width:1400px)': {
    gridTemplateColumns: '1fr',
  },
}));

export const LoadingWrapper = styled(Stack)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'rgba(0, 0, 0, 0.6)',
  borderRadius: '12px',
});
